module.exports = __webpack_public_path__ + "img/f-thermometer-img1-2.9e20c34d.png";